var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.commercial)?_c('commercial-banner-slider',{attrs:{"items":_vm.items}}):_c('banner-carousel',{attrs:{"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }